<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-header py-3">
        <div class="row">
          <div class="col-4">
            <IconField>
              <InputIcon>
                <i class="pi pi-search" />
              </InputIcon>
              <InputText v-model="table.search" type="text" size="small" placeholder="Search" class="rounded-pill w-100" @keyup="filter" />
            </IconField>
          </div>
          <div class="col-4"></div>
          <!-- open modal -->
          <div class="col-4">
            <div class="float-end">
              <ButtonPrime icon="pi pi-plus" label="Add New" size="small" severity="contrast" outlined @click="openAddModal"></ButtonPrime>

              <DialogPrime v-model:visible="modal.visible" modal header="Create FAQ" style="width: 25rem; margin: 10px;">
                <div class="mb-2">
                  <label for="question" class="font-semibold">Question <span class="text-danger">*</span></label>
                  <InputText id="question" v-model="modal.data.question" placeholder="Question" :class="`${(modal.errorMessage['question'] && modal.data.question == '') ? 'border-danger' : ''}`" fluid />
                  <small v-if="modal.errorMessage['question'] && modal.data.question == ''" class="text-danger">{{ modal.errorMessage['question'] }}</small>
                </div>

                <div class="mb-5">
                  <label for="answer" class="font-semibold">Answer <span class="text-danger">*</span></label>
                  <InputText id="answer" v-model="modal.data.answer" placeholder="Answer" :class="`${(modal.errorMessage['answer'] && modal.data.answer == '') ? 'border-danger' : ''}`" fluid />
                  <small v-if="modal.errorMessage['answer'] && modal.data.answer == ''" class="text-danger">{{ modal.errorMessage['answer'] }}</small>
                </div>

                <div class="d-flex justify-content-end gap-2">
                  <ButtonPrime type="button" label="Cancel" severity="secondary" @click="closeModal()"></ButtonPrime>
                  <ButtonPrime type="button" :disabled="modal.onLoading" @click="save()">
                    <span v-if="modal.onLoading"><i class="fas fa-spinner fa-spin"></i>&nbsp;&nbsp;&nbsp;Please wait</span>
                    <span v-else>Save</span>
                  </ButtonPrime>
                </div>
              </DialogPrime>
            </div>
          </div>
        </div>
      </div>
      <DataTable :value="filledTableData" size="null" removable-sort scrollable scroll-height="460px" table-style="min-width: 50rem">
        <Column field="question" header="Question" header-class="bg-light" sortable>
          <template v-if="table.onLoad" #body>
            <Skeleton></Skeleton>
          </template>
        </Column>
        <Column field="answer" header="Answer" header-class="bg-light" sortable>
          <template v-if="table.onLoad" #body>
            <Skeleton></Skeleton>
          </template>
        </Column>
        <Column field="created_at" header="Created at" header-class="bg-light" sortable>
          <template v-if="table.onLoad" #body>
            <Skeleton></Skeleton>
          </template>
        </Column>
        <Column header="Action" header-class="bg-light" style="width: 13%">
          <template #body="slotProps">
            <div v-if="slotProps.data?.question">
              <ButtonPrime icon="pi pi-pencil" outlined rounded size="small" @click="openEditModal(slotProps.data)" />
              <ButtonPrime icon="pi pi-trash" outlined rounded severity="danger" size="small" style="margin-left: 5px;" @click="deleteFaq(slotProps.data.id)" />
            </div>
            <!-- untuk row dengan colomn empty -->
            <div v-else class="m-4"><span /></div> 
          </template>
        </Column>
      </DataTable>
      <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
        <BasePagination v-model="table.page.current_pages" :page-count="table.page.total_pages" size="sm" @click="changePage()"/>
        <p>{{ (table.page.current_pages - 1) * table.page.per_pages + table.data.length }} of {{ table.total }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import faqService from "@/services/faqService";

export default {
  data() {
    return {
      loadTimeout: null,
      table: {
        onLoad: true,
        search: this.$route.query.search ? this.$route.query.search : "",
        total: 0,
        data: new Array(4),
        page: {
          current_pages: 1,
        },
        loadTimeout: null,
      },
      modal: {
        visible: false,
        action: "",
        title: "",
        data: {},
        errorMessage: {},
        onLoading: false,
      },
    };
  },
  computed: {
    filledTableData() {
      const visibleRows = this.table.data
      const dummyCount = Math.max(0, 7 - visibleRows.length)
      const dummies = Array.from({ length: dummyCount }, () => ({ __isDummy: true }))
      return [...visibleRows, ...dummies]
    }
  },
  watch: {
    "table.page.current_pages": {
      handler() {
        this.get();
      },
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    async get() {
      this.table.onLoad = true;

      try {
        const response = await api(this, faqService.list(this.table.page.current_pages, {search: this.table.search}), false);

        // console.log(response.data.data)
        
        this.table.data  = response.data.data;  
        this.table.total = response.data.total_items;
        this.table.page  = response.data;  
      } catch (error) {
        this.table.data = [];
        this.table.total = 0;
      } finally {
        this.table.onLoad = false;
      }
    },
    save() {
      if (this.modal.data.question == "" || this.modal.data.answer == "") {
        this.modal.errorMessage["question"] = "Question is required";
        this.modal.errorMessage["answer"] = "Answer is required";

        return false;
      }

      this.modal.onLoading = true;
      setTimeout(async () => {
        try {
          if (this.modal.action == 'create') {
            await api(this, faqService.create(this.modal.data), false);
          } else {
            await api(this, faqService.update(this.modal.data.id, this.modal.data), false);
          }

          this.modal.data = { question: "", answer: "" };
          this.modal.visible = false;
          this.get()
        } catch (error) {
          if (error.response?.data?.code == 400) {
            error.response.data.data.forEach((v) => {
              this.modal.errorMessage[v.path] = v.msg;
            });
          }
        } finally {
          this.modal.onLoading = false;
        }
      }, 500);
    },
    deleteFaq(id) {
      this.confirmDialog("You won't be able to revert this!", "delete").then((result) => {
        if (result.isConfirmed) {
          api(this, faqService.delete(id)).then(() => {
            this.get();
          });
        }
      });
    },
    filter() {
      if (this.table.search != this.$route.query.search) {
        clearTimeout(this.table.loadTimeout);
        this.table.loadTimeout = setTimeout(() => {
          if (this.table.search == "") {
            this.$router.push({ path: "/test", query: null });
          } else {
            this.$router.push({
              path: "/test",
              query: { search: this.table.search },
            });
          }

          this.get();
        }, 500);
      }
    },
    changePage() {
      this.table.onLoad = true;

      clearTimeout(this.table.loadTimeout);
      this.table.loadTimeout = setTimeout(() => {
        this.get();
      }, 100);
    },
    openAddModal() {
      this.modal.visible = true
      this.modal.action = "create";
      this.modal.title = "Add FAQ";
      this.modal.data = { question: "", answer: "" };
      this.errorMessage = {};
    },
    openEditModal(faq) {
      this.modal.visible = true
      this.modal.action = "update";
      this.modal.title = "Edit FAQ";
      this.modal.data = { ...faq };
      this.errorMessage = {};
    },
    closeModal() {
      this.modal.visible = false
    }
  },
};
</script>

<style scoped>  </style>